import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import { some } from 'lodash';
/**
 * Alias to Object.assign.
 */

export function assign() {
  return _Object$assign.apply(Object, arguments);
}
/**
 * Creates a validator function; when called, it will invoke all the fns, and
 * return true if any of them pass.
 * @param {Function[]} fns - Collection of predicates.
 * @returns {Function} Validator
 */

export function anyPass(fns) {
  return function validator(value) {
    return some(fns, function (fn) {
      return fn(value);
    });
  };
}
/**
 * Checks if the value exists.
 * @param value
 * @returns {boolean}
 */

export function exists(value) {
  return value != null;
}
/**
 * Reduces an array of values. Values can be promises.
 * @see https://github.com/sindresorhus/p-reduce
 */

export function promisedReduce(iterable, reducer, initVal) {
  return _reduceInstanceProperty(iterable).call(iterable, function (prev, next, i) {
    return prev.then(function (accum) {
      return _Promise.resolve(next).then(function (val) {
        return _Promise.resolve(reducer(accum, val, i));
      });
    });
  }, _Promise.resolve(initVal));
}